import { forwardRef } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import TextButton from 'LuxKit/Button/TextButton'
import SolidHeartIcon from 'LuxKit/Icons/solid/SolidHeartIcon'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import useRebrandVersion from 'hooks/useRebrandVersion'

const Container = styled.div`
  position: relative;
`

interface Props {
  onClick: (e: React.MouseEvent<HTMLButtonElement>, overRideVal?: boolean) => void
  isOpen?: boolean
}

const TripPlannerFloatingToggleButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const {
    onClick,
    isOpen = false,
  } = props

  const intl = useIntl()
  const isRebrand = useRebrandVersion() === 'rebrand'
  const buttonKind = isRebrand ? 'primary' : 'secondary'

  const savedText = intl.formatMessage({
    id: 'QLQpXxeFpBo6yloC9dAY',
    defaultMessage: 'Saved',
    description: 'Floating toggle button label for saved trips on the map',
  })

  return (
    <Container>
      <TextButton
        kind={buttonKind}
        variant="dark"
        size="large"
        shape="round"
        startIcon={<SolidHeartIcon colour="favourite" />}
        ref={ref}
        endIcon={<DropdownChevron direction={isOpen ? 'down' : 'up'} />}
        onClick={onClick}
      >
        {savedText}
      </TextButton>
    </Container>
  )
})

export default TripPlannerFloatingToggleButton
